import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

//** Lib's */
import "./Header.scss";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../../components/image/Image";
import Input from "../../../components/ui/inputs/input/Input";
import { getAuthProps } from "../../../lib/authenticationLibrary";
import HeaderSearch from "../../../features/headerSearch/component/HeaderSearch";
import { useLazyGetSearchByCandidateNameQuery } from "../../../app/services/userAPI";
import useDebounce from "../../../app/customHooks/useDebounce";
import Iconify from "../../../components/ui/iconify/Iconify";

//** Service */

const Header = () => {

  //** State */
  const cookie = getAuthProps();
  const location = useLocation();
  const navigate = useNavigate();
  const [isSearch, setIsSearch] = useState(false);
  const [dataSource, setDataSource] = useState();
  const [searchTerm, setSearchTerm] = useState("")
  //** API's Call */
  const [getSearchByName, { isLoading: isListLoading, isFetching, isSuccess: isGetSuccess, data: CandidateData }] = useLazyGetSearchByCandidateNameQuery();
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  // //** Handle Changes */
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    if (event.target.value.trim().length >= 3) {
      setIsSearch(true); // Potentially for UI changes or indicating that a search is active/not active
    } else {
      setIsSearch(false);
    }
  };
  
  const isConfigurationPage = location.pathname.includes("/SystemConfiguration");

  useEffect(() => {
    if (debouncedSearchTerm.length >= 3) {
      getSearchByName(debouncedSearchTerm);
    } else {
      setDataSource(undefined); // Optionally clear the data source if the search term is too short
    }
  }, [debouncedSearchTerm, getSearchByName]);

  useEffect(() => {
    if (!isFetching && isGetSuccess && CandidateData) {
      setDataSource(CandidateData);
    }
  }, [isFetching, isGetSuccess, CandidateData]);

  const onhandleClick = () => {
    navigate("/SystemConfiguration/InterviewRound");
  };

  const onBackMenu = () => {
    
    navigate("/");
  }
  return (
    <div className="header-section">
      <div className="logo-profile-section">
        <div className={`search-section ${isSearch ? 'search-main-header' : ''}`}>
          <Input name="searchBar" type="text"
            placeholder="Search By Candidate Name"
            autocomplete="off"
            onChange={handleChange} />
          <div className="search-btn">
            <Link>
              <Image
                imagePath={AppIcons.searchIcon}
                imgCustomClassName="open-bar"
                altText="User Image" />
            </Link>
          </div>
          <HeaderSearch
            candidateData={dataSource}
            searchValue={debouncedSearchTerm}
            isLoading={isListLoading} />
        </div>
        <div className="right-profile">

          {
            isConfigurationPage ?
              (<div className="right-configuration" onClick={onBackMenu}>
                <Iconify icon="ion:home" />
              </div>)
              :
              (<div className="right-configuration"
                onClick={onhandleClick}
              >
                <Iconify icon="weui:setting-filled" />
              </div>)
          }

          <div className="profile-part">

            <div className="profile-img">
              <Image
                imagePath={AppIcons.userImg}
                imgCustomClassName="open-bar"
                altText="User Image"
              />
            </div>
            <span className="user-name">
              {cookie && cookie != null
                ? cookie.user.email
                  ? cookie.user.email
                  : ""
                : ""}
            </span>
            {/* <span className="user-name">
            Global Admin
            {cookie && cookie != null
              ? cookie.user.userName
                ? cookie.user.userName
                : ""
              : ""}
          </span> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
